import React, { useEffect, useRef } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LabelList } from 'recharts'

const PDFBarChart4 = ({ data = [], width = 700, height = 600, onLoaded }) => {
  const chartRef = useRef()
  const hasLoaded = useRef(false)

  // 排序：先釣中人數大到小，再部門名稱 A→Z
  const sortedData = [...data].sort((a, b) => {
    if (b.caught !== a.caught) return b.caught - a.caught
    return a.depart.localeCompare(b.depart, 'zh-Hant')
  })

  // 轉換資料並只取前 10 筆
  const transformedData = sortedData
    .map(item => ({
      depart: item.depart,
      caught: item.caught,
      notCaught: item.notCaught,
      total: item.caught + item.notCaught,
    }))
    .slice(0, 10)

  // Y 軸最大值計算
  const maxValue = Math.max(...transformedData.map(item => item.total))
  const yAxisMax = maxValue + maxValue * 0.2
  const yAxisTicks = Array.from({ length: Math.floor(yAxisMax / 10) + 1 }, (_, i) => i * 10)

  // 圖表載入回調
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasLoaded.current) {
        hasLoaded.current = true
        onLoaded?.(chartRef.current)
      }
    }, 100)
    return () => clearTimeout(timer)
  }, [onLoaded])

  return (
    <div
      ref={chartRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '20px',
        border: '4px solid rgb(182, 180, 180)',
        width: '100%',
        boxSizing: 'border-box',
        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.3)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Label "單位: (人)" */}
      {/* <div style={{ position: 'absolute', top: 35, left: 20, fontSize: 17, fontWeight: 'bold' }}>
        單位: (人)
      </div> */}

      <BarChart
        width={width}
        height={height}
        data={transformedData}
        barCategoryGap={5}
        barGap={5}
        margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="depart"
          interval={0}
          tick={({ x, y, payload }) => {
            const angle = payload.value.length > 1 ? -45 : -30
            return (
              <text
                x={x + 10}
                y={y + 10}
                textAnchor="end"
                fill="#666"
                fontSize={14}
                fontWeight="bold"
                transform={`rotate(${angle}, ${x}, ${y + 20})`}
              >
                {payload.value}
              </text>
            )
          }}
        />
        <YAxis ticks={yAxisTicks} domain={[0, yAxisMax]} tickFormatter={value => `${value}`} />
        <Tooltip />
        <Bar
          dataKey="notCaught"
          stackId="a"
          fill="#f47e00"
          name="部門未釣中人數"
          barSize={20}
          style={{ filter: 'drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.3))' }}
        >
          <LabelList
            dataKey="notCaught"
            position="inside"
            fill="#ffffff"
            fontSize={12}
            offset={10}
            // style={{ fontWeight: 'bold' }}
          />
        </Bar>
        <Bar
          dataKey="caught"
          stackId="a"
          fill="#4da500"
          name="部門釣中人數"
          barSize={20}
          style={{ filter: 'drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.3))' }}
        >
          <LabelList
            dataKey="caught"
            position="inside"
            fill="#000000ff"
            fontSize={12}
            offset={10}
            // style={{ fontWeight: 'bold' }}
          />
        </Bar>
        <Legend
          wrapperStyle={{
            position: 'absolute',
            top: '-15px',
            fontSize: '17px',
            left: '50px',
          }}
          itemMargin={{ horizontal: 40, vertical: 20 }}
        />
      </BarChart>
    </div>
  )
}

export default PDFBarChart4
